// ** Initial State
const initialState = {
    allData: [],
    data: [],
    total: 1,
    params: {},
    selectedAuction: null
  }
  
  const lots = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_ALL_LOT_DATA':
        return { ...state, allData: action.data }
      case 'GET_LOT_DATA':
        return {
          ...state,
          data: action.data,
          total: action.totalPages,
          params: action.params
        }
      case 'GET_LOT':
        return { ...state, selectedAuction: action.selectedAuction }
      default:
        return { ...state }
    }
  }
  export default lots
  